import { gsap } from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import { KEY_CODES } from '@src/utils/constants';

gsap.registerPlugin(ScrollToPlugin);
gsap.defaults({
  duration: 0.4,
  ease: 'power2.inOut',
});

class InPageScroll {
  constructor() {
    this.nav = document.querySelector('.js-page-nav-ul');
    this.scrolledDown = false;

    if (this.nav) {
      this.links = Array.from(this.nav.querySelectorAll('a'));
      this.bindEvents();
    }
  }

  bindEvents() {
    this.links.forEach(link => {
      link.addEventListener('click', this.handleClick.bind(this));
      document.addEventListener('keyup', this.keyup.bind(this));
    });
  }

  handleClick(e) {
    e.preventDefault();
    const linkHash = e.target.hash;
    const tl = gsap.timeline();

    if (window.innerWidth >= 768) {
      tl.to(window, { scrollTo: { y: linkHash, offsetY: 65 } });
    } else {
      tl.to(window, { scrollTo: { y: linkHash, offsetY: 10 } });
    }
  }

  keyup(e) {
    if (e.keyCode === KEY_CODES.TAB) {
      this.links.forEach(link => {
        if (document.activeElement === link) {
          const linkHash = link.hash;

          gsap.to(window, { scrollTo: linkHash });
        }
      });
    }
  }
}

export default InPageScroll;
